import { FileNamesTemplate } from './models';
import dayjs from 'dayjs';

export const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 5 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
};

export const generateTimeBasedKey = (): string =>
  dayjs().format('YYYYMMDDHHmmssSSS');

export const buildFileNamesTemplate = (
  programKey: string,
): FileNamesTemplate => {
  return {
    mainFileName: `P_${programKey}_Main_File`,
    rejectFileName: `P_${programKey}_Reject_File`,
    statementFileName: `P_${programKey}_Statement_File`,
    zippedFileName: `P_${programKey}_Zipped_File`,
  };
};
